import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'
import { ScoringByItem } from '@app/models/scoringByItem'
import { PracticeTestAssessmentKeyItem, ResponsesByPracticeTest } from '@app/types'

export type ReviewStateType = {
  testScoring: ScoringByItem
  groupMode: boolean
  isPreviewMode: boolean
  questionPreviewId: string | null
  isQuestionPreviewMode: boolean
  groupTestScoring: ResponsesByPracticeTest
  groupCorrectAnswers: PracticeTestAssessmentKeyItem[]
}

const initialState: ReviewStateType = {
  testScoring: null,
  groupMode: false,
  isPreviewMode: false,
  questionPreviewId: null,
  isQuestionPreviewMode: false,
  groupTestScoring: null,
  groupCorrectAnswers: [],
}

export const ScoringState = proxy<ReviewStateType>(initialState)

export const setScoring = (data: ScoringByItem) => {
  ScoringState.testScoring = data
}

export const setGroupMode = (groupMode: boolean) => {
  ScoringState.groupMode = groupMode
}

export const setPreviewMode = (isPreviewMode: boolean) => {
  ScoringState.isPreviewMode = isPreviewMode
}

export const setQuestionPreviewModeData = (questionPreviewId: string | null) => {
  if (questionPreviewId === null) {
    ScoringState.questionPreviewId = null
    ScoringState.isQuestionPreviewMode = false
  } else {
    ScoringState.questionPreviewId = `ID_${questionPreviewId}`
    ScoringState.isQuestionPreviewMode = true
  }
}

export const setGroupTestScoring = (
  groupTestScoring: ResponsesByPracticeTest,
  groupCorrectAnswers: PracticeTestAssessmentKeyItem[],
) => {
  ScoringState.groupTestScoring = groupTestScoring
  ScoringState.groupCorrectAnswers = groupCorrectAnswers
}

export const resetReviewState = () => {
  ScoringState.testScoring = initialState.testScoring
  ScoringState.groupMode = initialState.groupMode
  ScoringState.isPreviewMode = initialState.isPreviewMode
  ScoringState.questionPreviewId = initialState.questionPreviewId
  ScoringState.isQuestionPreviewMode = initialState.isQuestionPreviewMode
  ScoringState.groupTestScoring = initialState.groupTestScoring
  ScoringState.groupCorrectAnswers = initialState.groupCorrectAnswers
}

process.env.NODE_ENV === 'development' && devtools(ScoringState, { enabled: true, name: 'ScoringState' })
